export default __webpack_public_path__ + "static/media/verify-email.4db0235f.webp";